<ng-container *transloco="let t;">

  <app-loader [loading]="loading === true"></app-loader>

  <ng-container *ngIf="loading !== true">
    <h3>{{ t('common.labels.placeholders') }}</h3>
    <table [ngClass]="{edit: edit === true}">
      <tr *ngFor="let placeholder of visiblePlaceholders">
        <td><span role="link" (click)="onPlaceholderClick('%' + placeholder.identifier + '%')">%{{ placeholder.identifier }}%</span></td>
        <td><i class="pi pi-info-circle" *ngIf="placeholder.preview" [pTooltip]="placeholder.preview" tooltipPosition="left"></i></td>
      </tr>
    </table>
    <h3 class="p-mt-4">{{ t('common.labels.textblocks') }}</h3>
    <table [ngClass]="{edit: edit === true}">
      <tr *ngFor="let textblock of visibleTextblocks">
        <td><span role="link" (click)="onPlaceholderClick('%' + textblock.identifier + '%')">%{{ textblock.identifier }}%</span></td>
        <td><i class="pi pi-info-circle" [pTooltip]="textblock.preview" tooltipPosition="left"></i></td>
      </tr>
    </table>
  </ng-container>

  <p-dialog [header]="t('common.labels.linktext')" [(visible)]="promptVisible" [draggable]="false" [resizable]="false" [modal]="true" [style]="{width: '50vw'}">
    <form #promptFormRef novalidate (submit)="onPlaceholderLinkInput()">
      <p>{{ t('placeholders.please_input_linktext') }}</p>
      <app-form-control [cid]="'link'" [control]="promptForm.get('link')" [type]="'input'" [label]="t('common.labels.linktext')"></app-form-control>
      <p class="p-text-right">
        <button pButton type="submit">{{t('common.ok')}}</button>
      </p>
    </form>
  </p-dialog>

</ng-container>
